export default {
  PRE_MONEY: 'Pre-Money',
  POST_MONEY: 'Post-Money',
};